<!--Author: Michał Pawłowski-->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" style="display: none">
    <symbol id="backward" viewBox="0 0 118 94">
      <title>Backward</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m256 488a23.928 23.928 0 0 1 -16.971-7.029l-208-208a24 24 0 0 1 0-33.942l208-208a24 24 0 0 1 33.942 33.942l-191.03 191.029 191.03 191.029a24 24 0 0 1 -16.971 40.971zm224.971-7.029a24 24 0 0 0 0-33.942l-191.03-191.029 191.03-191.029a24 24 0 0 0 -33.942-33.942l-208 208a24 24 0 0 0 0 33.942l208 208a24 24 0 0 0 33.942 0z"
      ></path>
    </symbol>
    <symbol id="forward" viewBox="0 0 118 94">
      <title>Forward</title>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="m256 488a24 24 0 0 1 -16.971-40.971l191.03-191.029-191.03-191.029a24 24 0 0 1 33.942-33.942l208 208a24 24 0 0 1 0 33.942l-208 208a23.928 23.928 0 0 1 -16.971 7.029zm-191.029-7.029 208-208a24 24 0 0 0 0-33.942l-208-208a24 24 0 0 0 -33.942 33.942l191.03 191.029-191.03 191.029a24 24 0 0 0 33.942 33.942z"
      ></path>
    </symbol>
  </svg>

  <div>
    <nav aria-label="...">
      <ul class="pagination">
        <li class="page-item">
          <a class="page-link" href="#" @click="toTheFirstPage">
            <i class="fas fa-fast-backward" />
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#" @click="previousPage">
            <i class="fas fa-backward" />
          </a>
        </li>
        <div v-for="page in availablePages" :key="page">
          <li
            v-if="visiblePageCondition(page)"
            :class="pageItemClass"
            @click="getItems(page)"
            style="display: block"
          >
            <a
              class="page-link"
              :id="prefix + page + '_page'"
              :ref="prefix + page + '_page'"
              href="#"
              >{{ page }}</a
            >
          </li>
          <li v-else :class="pageItemClass" style="display: none">
            <a
              class="page-link"
              :id="prefix + page + '_page'"
              :ref="prefix + page + '_page'"
              href="#"
              >{{ page }}</a
            >
          </li>
        </div>
        <li class="page-item">
          <a class="page-link" href="#" @click="nextPage">
            <i class="fas fa-forward" />
          </a>
        </li>
        <li class="page-item">
          <a class="page-link" href="#" @click="toTheLastPage">
            <!--          <svg width="64" height="64"><use xlink:href="#forward"/></svg>-->
            <i class="fas fa-fast-forward" />
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import {log} from "@/state/pinia/log";

export default {
  name: "PaginationComponent",
  components: {
    // FontAwesomeIcon,
  },
  props: {
    pagesCount: Number,
    prefix: String,
  },
  emits: ["currentPageChanged"],
  data() {
    return {
      currentPage: 0,
      pageItemClass: "page-item",
    };
  },
  computed: {
    availablePages() {
      var pages = [];
      for (let i = 0; i < this.pagesCount; i++) {
        pages.push(i);
      }
      return pages;
    },
  },
  methods: {
    visiblePageCondition(page) {
      var pagesNumbersUpperLimit = this.currentPage + 4;
      var pagesNumbersLowerLimit = this.currentPage - 4;
      if (page >= pagesNumbersLowerLimit && page <= pagesNumbersUpperLimit) {
        return true;
      } else {
        return false;
      }
    },
    toTheFirstPage() {
      this.currentPage = 0;
      this.setFocusOnCurrentPageNumber();
    },
    toTheLastPage() {
      this.currentPage = this.pagesCount - 1;
      this.setFocusOnCurrentPageNumber();
    },
    nextPage() {
      if (this.pagesCount > 1) {
        if (this.currentPage < this.pagesCount - 1) {
          this.currentPage++;
        } else {
          this.currentPage = 0;
        }
        this.getItems(this.currentPage);
        this.setFocusOnCurrentPageNumber();
      }
    },
    previousPage() {
      if (this.pagesCount > 1) {
        log.log("this.currentPage");
        log.log(this.currentPage);
        if (this.currentPage > 0) {
          this.currentPage--;
        } else {
          this.currentPage = this.pagesCount - 1;
        }
        this.getItems(this.currentPage);
        this.setFocusOnCurrentPageNumber();
      }
    },
    setFocusOnCurrentPageNumber() {
      var pageRef = this.prefix + this.currentPage + "_page";
      var pageNumberField = this.$refs[pageRef][0];
      pageNumberField.focus();
    },
    getItems(page) {
      this.currentPage = page;
      this.$emit("currentPageChanged", page);
      //
      // this.$store.commit(this.setItemsMethodName, []);
      // var requestPayload = {
      //   currentPage: this.currentPage,
      //   searchAndFilterRequest: this.filterSettingsPayload,
      // };
      //
      // log.log("Fetching next page: " + requestPayload + ", method name: " + this.getItemsPagingMethodName)
      // this.$store.dispatch(this.getItemsPagingMethodName, requestPayload);
    },
  },
  // watch: {
  //   currentPage: {
  //     handler(newVal) {
  //       this.$emit("currentPageChanged", newVal);
  //     },
  //     deep: true,
  //   },
  // },
};
</script>

<style scoped></style>
